import './vendor/body-scroll-lock';
import './vendor/aos';

